import {
	IonItem,
	IonLabel,
	IonNote,
	IonList,
	IonCheckbox,
	IonTextarea,
} from "@ionic/react";
import React from "react";

interface props {
	field: any;
	fieldName: any;
	onChange: any;
}

const FormResponses: React.FC<props> = ({ field, fieldName, onChange }) => {
	return (
		<IonList>
			<IonItem lines="none">
				<IonCheckbox
					slot="start"
					onIonChange={onChange}
					id="laydown"
					data-id={fieldName}
					name="laydown"
					checked={field.laydown}
				/>
				<IonLabel>Lay down or cuddled child</IonLabel>
			</IonItem>
			<IonItem lines="none">
				<IonCheckbox
					slot="start"
					onIonChange={onChange}
					id="sat"
					data-id={fieldName}
					name="sat"
					checked={field.sat}
				/>
				<IonLabel>Sat beside child's bed</IonLabel>
			</IonItem>
			<IonItem lines="none">
				<IonCheckbox
					slot="start"
					onIonChange={onChange}
					id="returned"
					data-id={fieldName}
					name="returned"
					checked={field.returned}
				/>
				<IonLabel>Returned child to bed</IonLabel>
			</IonItem>
			<IonItem lines="none">
				<IonCheckbox
					slot="start"
					onIonChange={onChange}
					id="providedItems"
					data-id={fieldName}
					name="providedItems"
					checked={field.providedItems}
				/>
				<IonLabel>Provided access to requested items</IonLabel>
			</IonItem>
			<IonItem lines="none">
				<IonCheckbox
					slot="start"
					onIonChange={onChange}
					id="removedItems"
					data-id={fieldName}
					name="removedItems"
					checked={field.removedItems}
				/>
				<IonLabel>Removed items/activities</IonLabel>
			</IonItem>
			<IonItem lines="none">
				<IonCheckbox
					slot="start"
					onIonChange={onChange}
					id="reprimanded"
					data-id={fieldName}
					name="reprimanded"
					checked={field.reprimanded}
				/>
				<IonLabel>Reprimanded (told off) child</IonLabel>
			</IonItem>
			<IonItem lines="none">
				<IonCheckbox
					slot="start"
					onIonChange={onChange}
					id="instructed"
					data-id={fieldName}
					name="instructed"
					checked={field.instructed}
				/>
				<IonLabel>Instructed/guided child on what to do</IonLabel>
			</IonItem>
			<IonItem lines="none">
				<IonCheckbox
					slot="start"
					onIonChange={onChange}
					id="breastfed"
					data-id={fieldName}
					name="breastfed"
					checked={field.breastfed}
				/>
				<IonLabel>Breastfed</IonLabel>
			</IonItem>
			<IonItem lines="none">
				<IonCheckbox
					slot="start"
					onIonChange={onChange}
					id="allowed"
					data-id={fieldName}
					name="allowed"
					checked={field.allowed}
				/>
				<IonLabel>Allowed the child to stay up</IonLabel>
			</IonItem>
			<IonItem lines="none">
				<IonCheckbox
					slot="start"
					onIonChange={onChange}
					id="ignored"
					data-id={fieldName}
					name="ignored"
					checked={field.ignored}
				/>
				<IonLabel>Ignored child</IonLabel>
			</IonItem>
			<IonItem lines="none">
				<IonCheckbox
					slot="start"
					onIonChange={onChange}
					id="leftRoom"
					data-id={fieldName}
					name="leftRoom"
					checked={field.leftRoom}
				/>
				<IonLabel>Left the room</IonLabel>
			</IonItem>
			<IonItem lines="none">
				<IonCheckbox
					slot="start"
					onIonChange={onChange}
					id="removedFromBed"
					data-id={fieldName}
					name="removedFromBed"
					checked={field.removedFromBed}
				/>
				<IonLabel>Removed child from bed</IonLabel>
			</IonItem>
			<IonItem lines="none">
				<IonCheckbox
					slot="start"
					onIonChange={onChange}
					id="siblingLeft"
					data-id={fieldName}
					name="siblingLeft"
					checked={field.siblingLeft}
				/>
				<IonLabel>Sibling left room</IonLabel>
			</IonItem>
			<IonItem lines="none">
				<IonCheckbox
					slot="start"
					onIonChange={onChange}
					id="parentBed"
					data-id={fieldName}
					name="parentBed"
					checked={field.parentBed}
				/>
				<IonLabel>Allowed child to sleep in parental bed</IonLabel>
			</IonItem>
			<IonItem lines="none">
				<IonCheckbox
					slot="start"
					onIonChange={onChange}
					id="clothing"
					data-id={fieldName}
					name="clothing"
					checked={field.clothing}
				/>
				<IonLabel>Changed clothing</IonLabel>
			</IonItem>
			<IonItem lines="none">
				<IonCheckbox
					slot="start"
					onIonChange={onChange}
					id="strategies"
					data-id={fieldName}
					name="strategies"
					checked={field.strategies}
				/>
				<IonLabel>Used taught strategies</IonLabel>
			</IonItem>
			<IonItem lines="none">
				<IonCheckbox
					slot="start"
					onIonChange={onChange}
					id="other"
					data-id={fieldName}
					name="other"
					checked={field.other}
				/>
				<IonLabel>Other</IonLabel>
			</IonItem>
			{field.other && (
				<IonItem>
					<IonLabel position="stacked">
						Please describe other responses
					</IonLabel>
					<IonTextarea
						name="otherDescribe"
						id="otherDescribe"
						data-id={fieldName}
						value={field.otherDescribe}
						onIonChange={onChange}
					/>
				</IonItem>
			)}
		</IonList>
	);
};

export default FormResponses;
